module.exports = __webpack_public_path__ + "images/internal/datashake/walmart.png";